(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('handbook-node', {
            parent: 'entity',
            url: '/handbook-node?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookNode.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-node/handbook-nodes.html',
                    controller: 'HandbookNodeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookNode');
                    $translatePartialLoader.addPart('handbookNodeType');
                    $translatePartialLoader.addPart('handbookNodeAccessRights');
                    $translatePartialLoader.addPart('mergeState');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('handbook-node-detail', {
            parent: 'handbook-node',
            url: '/handbook-node/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookNode.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-node/handbook-node-detail.html',
                    controller: 'HandbookNodeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookNode');
                    $translatePartialLoader.addPart('handbookNodeType');
                    $translatePartialLoader.addPart('handbookNodeAccessRights');
                    $translatePartialLoader.addPart('mergeState');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HandbookNode', function($stateParams, HandbookNode) {
                    return HandbookNode.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'handbook-node',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('handbook-node-detail.edit', {
            parent: 'handbook-node-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-node/handbook-node-dialog.html',
                    controller: 'HandbookNodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookNode', function(HandbookNode) {
                            return HandbookNode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-node.new', {
            parent: 'handbook-node',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-node/handbook-node-dialog.html',
                    controller: 'HandbookNodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                content: null,
                                type: null,
                                accessRights: null,
                                visible: null,
                                nodeUUID: null,
                                canAddHeading: null,
                                canDelete: null,
                                canEdit: null,
                                info: null,
                                treeLabel: null,
                                treeCheckboxVisible: false,
                                mergeState: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('handbook-node', null, { reload: 'handbook-node' });
                }, function() {
                    $state.go('handbook-node');
                });
            }]
        })
        .state('handbook-node.edit', {
            parent: 'handbook-node',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-node/handbook-node-dialog.html',
                    controller: 'HandbookNodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookNode', function(HandbookNode) {
                            return HandbookNode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-node', null, { reload: 'handbook-node' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-node.delete', {
            parent: 'handbook-node',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-node/handbook-node-delete-dialog.html',
                    controller: 'HandbookNodeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HandbookNode', function(HandbookNode) {
                            return HandbookNode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-node', null, { reload: 'handbook-node' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
